// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__qAv3w","arrow":"Tooltip_arrow__mp+06"};